import { useState } from "react";
import { Plus, Minus } from "lucide-react";

/**
 * Visible FAQ section — content mirrors the FAQPage JSON-LD in public/index.html
 * so Google sees consistency between rendered content and structured data.
 */
const FAQS = [
  {
    q: "What is Instagram DM automation?",
    a: "Instagram DM automation lets you reply instantly to direct messages and comments based on keywords. InstaVibe sends your follower a link, freebie, or personalised note the moment they message a trigger word — 24/7, without you watching the inbox.",
  },
  {
    q: "Is InstaVibe a Meta-approved Instagram marketing bot?",
    a: "Yes. InstaVibe is a Meta Verified Business Tech Provider and uses the official Instagram Graph API. No fake accounts, no scraping, no shadow-ban risk.",
  },
  {
    q: "How much does InstaVibe cost?",
    a: "Starter is $9.99/month or $99/year. Pro is $29.99/month or $299/year. Both plans include a 14-day free trial with no credit card required.",
  },
  {
    q: "Does InstaVibe work for small business?",
    a: "Yes. InstaVibe is designed specifically for creators, coaches, and small e-commerce brands who want to convert Instagram comments into DMs into sales without hiring a community manager.",
  },
  {
    q: "Can I auto-reply to Instagram comments?",
    a: "Yes. InstaVibe supports comment-to-DM automation: when a follower comments a keyword on your post, InstaVibe replies publicly and slides a personalised DM into their inbox using Instagram Private Reply.",
  },
  {
    q: "How fast can I get my first automation live?",
    a: "Under ten minutes. Sign up, connect your Instagram business account via Meta OAuth, create your first keyword flow (e.g., trigger: \"price\" → reply: your pricing page link), and you're live.",
  },
];

export default function LandingFAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      className="py-20 sm:py-24 md:py-32 px-4 sm:px-6 md:px-12 max-w-[1100px] mx-auto"
      data-testid="landing-faq-section"
    >
      <div className="text-center mb-10 sm:mb-14">
        <div className="overline mb-3">— Frequently asked</div>
        <h2 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-tight" data-testid="landing-faq-heading">
          Questions creators<br className="sm:hidden" /> ask us most.
        </h2>
      </div>
      <div className="space-y-3" data-testid="landing-faq-list">
        {FAQS.map((item, idx) => {
          const isOpen = open === idx;
          return (
            <div
              key={item.q}
              className={`surface-card overflow-hidden transition-colors ${isOpen ? "border-klein/40" : ""}`}
              data-testid={`landing-faq-item-${idx}`}
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : idx)}
                className="w-full flex items-start justify-between gap-4 text-left p-5 sm:p-6 hover:bg-white/[0.02]"
                aria-expanded={isOpen}
                data-testid={`landing-faq-trigger-${idx}`}
              >
                <span className="font-heading font-bold text-base sm:text-lg leading-snug pr-2">{item.q}</span>
                <span className="shrink-0 mt-0.5 text-klein">
                  {isOpen ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                </span>
              </button>
              {isOpen && (
                <div className="px-5 sm:px-6 pb-5 sm:pb-6 -mt-1 text-sm sm:text-base text-white/70 leading-relaxed" data-testid={`landing-faq-answer-${idx}`}>
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
